











































import Vue from 'vue';
import { PressaoArterial } from '../../../../back/src/entity/PressaoArterial';

export default Vue.extend({
  name: 'PressaoArterialAlert',
  props: {
    pressaoArterial: {
      type: Object as () => PressaoArterial,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    colorPressaoArterial() {
      if (this.pressaoArterial.remover) {
        return 'error';
      }
      if (this.pressaoArterial.id) {
        return 'primary';
      }
      return 'success';
    },
    colorInfoPressaoArterial() {
      if (this.pressaoArterial.remover) {
        return 'error';
      }
      if (this.pressaoArterial.observacoes) {
        return 'primary';
      }
      return 'grey';
    },
  },
});
